import * as MatchAPI from '../api/match';
import * as Types from '../Types';
const SUPPORTED_TREND_CATEGORIES = {
    '1X2': 0,
    H2H: 0,
    DC: 1,
    'H2H - DC': 1
};
function filterTrends(trends) {
    return trends.filter(trend => {
        return Object.keys(SUPPORTED_TREND_CATEGORIES).indexOf(trend.trendCategory) !== -1;
    });
}
function sortFunction(trendA, trendB) {
    if (SUPPORTED_TREND_CATEGORIES[trendA.trendCategory] > SUPPORTED_TREND_CATEGORIES[trendB.trendCategory])
        return 1;
    if (SUPPORTED_TREND_CATEGORIES[trendA.trendCategory] === SUPPORTED_TREND_CATEGORIES[trendB.trendCategory] &&
        trendA.trendScore &&
        trendB.trendScore &&
        trendA.trendScore > trendB.trendScore) {
        return 1;
    }
    if (SUPPORTED_TREND_CATEGORIES[trendA.trendCategory] < SUPPORTED_TREND_CATEGORIES[trendB.trendCategory])
        return -1;
    if (SUPPORTED_TREND_CATEGORIES[trendA.trendCategory] === SUPPORTED_TREND_CATEGORIES[trendB.trendCategory] &&
        trendA.trendScore &&
        trendB.trendScore &&
        trendA.trendScore < trendB.trendScore) {
        return -1;
    }
    return 0;
}
export function getTrendForMatch(match, language, fallbackLanguages, bettingType) {
    if (!match)
        return null;
    if (!match.metadata)
        return null;
    if (!match.metadata.trends)
        return null;
    if (!match.metadata.trends.trends)
        return null;
    // Temporary deactivated
    if ([Types.Language.nl, Types.Language.sv, Types.Language.fr].includes(language))
        return null;
    // TODO: Add support for more trend categories
    if (bettingType !== MatchAPI.BettingType.MatchWin)
        return null;
    const trend = filterTrends(match.metadata.trends.trends).sort(sortFunction)[0];
    if (!trend)
        return null;
    let trendsForLanguage;
    trendsForLanguage = trend.languages[language];
    if (!trendsForLanguage && fallbackLanguages) {
        if (fallbackLanguages[language]) {
            fallbackLanguages[language].some(fallbackLanguage => {
                trendsForLanguage = trend.languages[fallbackLanguage];
                if (trendsForLanguage)
                    return true;
                return false;
            });
        }
    }
    return trendsForLanguage ? trendsForLanguage.trend : null;
}
//# sourceMappingURL=TrendUtils.js.map